var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iEditTips"},[_c('Button',{staticClass:"btn",attrs:{"type":"text"},on:{"click":function($event){_vm.event();_vm.editTips()}}},[_vm._v(_vm._s(_vm.tipBtnType)+"提示")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }